/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntities } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntities';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntitiesFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntitiesFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntitiesToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntities';
import type { ExecRiskIdRelatedOrgTxblCorpTr } from './ExecRiskIdRelatedOrgTxblCorpTr';
import {
    ExecRiskIdRelatedOrgTxblCorpTrFromJSON,
    ExecRiskIdRelatedOrgTxblCorpTrFromJSONTyped,
    ExecRiskIdRelatedOrgTxblCorpTrToJSON,
} from './ExecRiskIdRelatedOrgTxblCorpTr';
import type { ExecRiskIdRelatedOrgTxblPartnership } from './ExecRiskIdRelatedOrgTxblPartnership';
import {
    ExecRiskIdRelatedOrgTxblPartnershipFromJSON,
    ExecRiskIdRelatedOrgTxblPartnershipFromJSONTyped,
    ExecRiskIdRelatedOrgTxblPartnershipToJSON,
} from './ExecRiskIdRelatedOrgTxblPartnership';
import type { ExecRiskIdRelatedTaxExemptOrg } from './ExecRiskIdRelatedTaxExemptOrg';
import {
    ExecRiskIdRelatedTaxExemptOrgFromJSON,
    ExecRiskIdRelatedTaxExemptOrgFromJSONTyped,
    ExecRiskIdRelatedTaxExemptOrgToJSON,
} from './ExecRiskIdRelatedTaxExemptOrg';
import type { ExecRiskSupplementalInformationDetail } from './ExecRiskSupplementalInformationDetail';
import {
    ExecRiskSupplementalInformationDetailFromJSON,
    ExecRiskSupplementalInformationDetailFromJSONTyped,
    ExecRiskSupplementalInformationDetailToJSON,
} from './ExecRiskSupplementalInformationDetail';
import type { ExecRiskTransactionsRelatedOrg } from './ExecRiskTransactionsRelatedOrg';
import {
    ExecRiskTransactionsRelatedOrgFromJSON,
    ExecRiskTransactionsRelatedOrgFromJSONTyped,
    ExecRiskTransactionsRelatedOrgToJSON,
} from './ExecRiskTransactionsRelatedOrg';
import type { ExecRiskUnrelatedOrgTxblPartnership } from './ExecRiskUnrelatedOrgTxblPartnership';
import {
    ExecRiskUnrelatedOrgTxblPartnershipFromJSON,
    ExecRiskUnrelatedOrgTxblPartnershipFromJSONTyped,
    ExecRiskUnrelatedOrgTxblPartnershipToJSON,
} from './ExecRiskUnrelatedOrgTxblPartnership';

/**
 * 
 * @export
 * @interface ExecRiskForm990ScheduleR
 */
export interface ExecRiskForm990ScheduleR {
    /**
     * 
     * @type {Array<ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntities>}
     * @memberof ExecRiskForm990ScheduleR
     */
    IdDisregardedEntitiesGrp?: Array<ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntities>;
    /**
     * 
     * @type {Array<ExecRiskIdRelatedTaxExemptOrg>}
     * @memberof ExecRiskForm990ScheduleR
     */
    IdRelatedTaxExemptOrgGrp?: Array<ExecRiskIdRelatedTaxExemptOrg>;
    /**
     * 
     * @type {Array<ExecRiskIdRelatedOrgTxblPartnership>}
     * @memberof ExecRiskForm990ScheduleR
     */
    IdRelatedOrgTxblPartnershipGrp?: Array<ExecRiskIdRelatedOrgTxblPartnership>;
    /**
     * 
     * @type {Array<ExecRiskIdRelatedOrgTxblCorpTr>}
     * @memberof ExecRiskForm990ScheduleR
     */
    IdRelatedOrgTxblCorpTrGrp?: Array<ExecRiskIdRelatedOrgTxblCorpTr>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    ReceiptOfIntAnntsRntsRyltsInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    GiftGrntOrCapContriToOthOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    GiftGrntCapContriFromOthOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    LoansOrGuaranteesToOtherOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    LoansOrGuaranteesFromOthOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    DivRelatedOrganizationInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    AssetSaleToOtherOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    AssetPurchaseFromOtherOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    AssetExchangeInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    RentalOfFacilitiesToOthOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    RentalOfFcltsFromOthOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    PerformOfServicesForOthOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    PerformOfServicesByOtherOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    SharingOfFacilitiesInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    PaidEmployeesSharingInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    ReimbursementPaidToOtherOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    ReimbursementPaidByOtherOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    TransferToOtherOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleR
     */
    TransferFromOtherOrgInd?: string;
    /**
     * 
     * @type {Array<ExecRiskTransactionsRelatedOrg>}
     * @memberof ExecRiskForm990ScheduleR
     */
    TransactionsRelatedOrgGrp?: Array<ExecRiskTransactionsRelatedOrg>;
    /**
     * 
     * @type {Array<ExecRiskUnrelatedOrgTxblPartnership>}
     * @memberof ExecRiskForm990ScheduleR
     */
    UnrelatedOrgTxblPartnershipGrp?: Array<ExecRiskUnrelatedOrgTxblPartnership>;
    /**
     * 
     * @type {Array<ExecRiskSupplementalInformationDetail>}
     * @memberof ExecRiskForm990ScheduleR
     */
    SupplementalInformationDetail?: Array<ExecRiskSupplementalInformationDetail>;
}

/**
 * Check if a given object implements the ExecRiskForm990ScheduleR interface.
 */
export function instanceOfExecRiskForm990ScheduleR(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskForm990ScheduleRFromJSON(json: any): ExecRiskForm990ScheduleR {
    return ExecRiskForm990ScheduleRFromJSONTyped(json, false);
}

export function ExecRiskForm990ScheduleRFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskForm990ScheduleR {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'IdDisregardedEntitiesGrp': !exists(json, 'IdDisregardedEntitiesGrp') ? undefined : ((json['IdDisregardedEntitiesGrp'] as Array<any>).map(ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntitiesFromJSON)),
        'IdRelatedTaxExemptOrgGrp': !exists(json, 'IdRelatedTaxExemptOrgGrp') ? undefined : ((json['IdRelatedTaxExemptOrgGrp'] as Array<any>).map(ExecRiskIdRelatedTaxExemptOrgFromJSON)),
        'IdRelatedOrgTxblPartnershipGrp': !exists(json, 'IdRelatedOrgTxblPartnershipGrp') ? undefined : ((json['IdRelatedOrgTxblPartnershipGrp'] as Array<any>).map(ExecRiskIdRelatedOrgTxblPartnershipFromJSON)),
        'IdRelatedOrgTxblCorpTrGrp': !exists(json, 'IdRelatedOrgTxblCorpTrGrp') ? undefined : ((json['IdRelatedOrgTxblCorpTrGrp'] as Array<any>).map(ExecRiskIdRelatedOrgTxblCorpTrFromJSON)),
        'ReceiptOfIntAnntsRntsRyltsInd': !exists(json, 'ReceiptOfIntAnntsRntsRyltsInd') ? undefined : json['ReceiptOfIntAnntsRntsRyltsInd'],
        'GiftGrntOrCapContriToOthOrgInd': !exists(json, 'GiftGrntOrCapContriToOthOrgInd') ? undefined : json['GiftGrntOrCapContriToOthOrgInd'],
        'GiftGrntCapContriFromOthOrgInd': !exists(json, 'GiftGrntCapContriFromOthOrgInd') ? undefined : json['GiftGrntCapContriFromOthOrgInd'],
        'LoansOrGuaranteesToOtherOrgInd': !exists(json, 'LoansOrGuaranteesToOtherOrgInd') ? undefined : json['LoansOrGuaranteesToOtherOrgInd'],
        'LoansOrGuaranteesFromOthOrgInd': !exists(json, 'LoansOrGuaranteesFromOthOrgInd') ? undefined : json['LoansOrGuaranteesFromOthOrgInd'],
        'DivRelatedOrganizationInd': !exists(json, 'DivRelatedOrganizationInd') ? undefined : json['DivRelatedOrganizationInd'],
        'AssetSaleToOtherOrgInd': !exists(json, 'AssetSaleToOtherOrgInd') ? undefined : json['AssetSaleToOtherOrgInd'],
        'AssetPurchaseFromOtherOrgInd': !exists(json, 'AssetPurchaseFromOtherOrgInd') ? undefined : json['AssetPurchaseFromOtherOrgInd'],
        'AssetExchangeInd': !exists(json, 'AssetExchangeInd') ? undefined : json['AssetExchangeInd'],
        'RentalOfFacilitiesToOthOrgInd': !exists(json, 'RentalOfFacilitiesToOthOrgInd') ? undefined : json['RentalOfFacilitiesToOthOrgInd'],
        'RentalOfFcltsFromOthOrgInd': !exists(json, 'RentalOfFcltsFromOthOrgInd') ? undefined : json['RentalOfFcltsFromOthOrgInd'],
        'PerformOfServicesForOthOrgInd': !exists(json, 'PerformOfServicesForOthOrgInd') ? undefined : json['PerformOfServicesForOthOrgInd'],
        'PerformOfServicesByOtherOrgInd': !exists(json, 'PerformOfServicesByOtherOrgInd') ? undefined : json['PerformOfServicesByOtherOrgInd'],
        'SharingOfFacilitiesInd': !exists(json, 'SharingOfFacilitiesInd') ? undefined : json['SharingOfFacilitiesInd'],
        'PaidEmployeesSharingInd': !exists(json, 'PaidEmployeesSharingInd') ? undefined : json['PaidEmployeesSharingInd'],
        'ReimbursementPaidToOtherOrgInd': !exists(json, 'ReimbursementPaidToOtherOrgInd') ? undefined : json['ReimbursementPaidToOtherOrgInd'],
        'ReimbursementPaidByOtherOrgInd': !exists(json, 'ReimbursementPaidByOtherOrgInd') ? undefined : json['ReimbursementPaidByOtherOrgInd'],
        'TransferToOtherOrgInd': !exists(json, 'TransferToOtherOrgInd') ? undefined : json['TransferToOtherOrgInd'],
        'TransferFromOtherOrgInd': !exists(json, 'TransferFromOtherOrgInd') ? undefined : json['TransferFromOtherOrgInd'],
        'TransactionsRelatedOrgGrp': !exists(json, 'TransactionsRelatedOrgGrp') ? undefined : ((json['TransactionsRelatedOrgGrp'] as Array<any>).map(ExecRiskTransactionsRelatedOrgFromJSON)),
        'UnrelatedOrgTxblPartnershipGrp': !exists(json, 'UnrelatedOrgTxblPartnershipGrp') ? undefined : ((json['UnrelatedOrgTxblPartnershipGrp'] as Array<any>).map(ExecRiskUnrelatedOrgTxblPartnershipFromJSON)),
        'SupplementalInformationDetail': !exists(json, 'SupplementalInformationDetail') ? undefined : ((json['SupplementalInformationDetail'] as Array<any>).map(ExecRiskSupplementalInformationDetailFromJSON)),
    };
}

export function ExecRiskForm990ScheduleRToJSON(value?: ExecRiskForm990ScheduleR | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IdDisregardedEntitiesGrp': value.IdDisregardedEntitiesGrp === undefined ? undefined : ((value.IdDisregardedEntitiesGrp as Array<any>).map(ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleRIdDisregardedEntitiesToJSON)),
        'IdRelatedTaxExemptOrgGrp': value.IdRelatedTaxExemptOrgGrp === undefined ? undefined : ((value.IdRelatedTaxExemptOrgGrp as Array<any>).map(ExecRiskIdRelatedTaxExemptOrgToJSON)),
        'IdRelatedOrgTxblPartnershipGrp': value.IdRelatedOrgTxblPartnershipGrp === undefined ? undefined : ((value.IdRelatedOrgTxblPartnershipGrp as Array<any>).map(ExecRiskIdRelatedOrgTxblPartnershipToJSON)),
        'IdRelatedOrgTxblCorpTrGrp': value.IdRelatedOrgTxblCorpTrGrp === undefined ? undefined : ((value.IdRelatedOrgTxblCorpTrGrp as Array<any>).map(ExecRiskIdRelatedOrgTxblCorpTrToJSON)),
        'ReceiptOfIntAnntsRntsRyltsInd': value.ReceiptOfIntAnntsRntsRyltsInd,
        'GiftGrntOrCapContriToOthOrgInd': value.GiftGrntOrCapContriToOthOrgInd,
        'GiftGrntCapContriFromOthOrgInd': value.GiftGrntCapContriFromOthOrgInd,
        'LoansOrGuaranteesToOtherOrgInd': value.LoansOrGuaranteesToOtherOrgInd,
        'LoansOrGuaranteesFromOthOrgInd': value.LoansOrGuaranteesFromOthOrgInd,
        'DivRelatedOrganizationInd': value.DivRelatedOrganizationInd,
        'AssetSaleToOtherOrgInd': value.AssetSaleToOtherOrgInd,
        'AssetPurchaseFromOtherOrgInd': value.AssetPurchaseFromOtherOrgInd,
        'AssetExchangeInd': value.AssetExchangeInd,
        'RentalOfFacilitiesToOthOrgInd': value.RentalOfFacilitiesToOthOrgInd,
        'RentalOfFcltsFromOthOrgInd': value.RentalOfFcltsFromOthOrgInd,
        'PerformOfServicesForOthOrgInd': value.PerformOfServicesForOthOrgInd,
        'PerformOfServicesByOtherOrgInd': value.PerformOfServicesByOtherOrgInd,
        'SharingOfFacilitiesInd': value.SharingOfFacilitiesInd,
        'PaidEmployeesSharingInd': value.PaidEmployeesSharingInd,
        'ReimbursementPaidToOtherOrgInd': value.ReimbursementPaidToOtherOrgInd,
        'ReimbursementPaidByOtherOrgInd': value.ReimbursementPaidByOtherOrgInd,
        'TransferToOtherOrgInd': value.TransferToOtherOrgInd,
        'TransferFromOtherOrgInd': value.TransferFromOtherOrgInd,
        'TransactionsRelatedOrgGrp': value.TransactionsRelatedOrgGrp === undefined ? undefined : ((value.TransactionsRelatedOrgGrp as Array<any>).map(ExecRiskTransactionsRelatedOrgToJSON)),
        'UnrelatedOrgTxblPartnershipGrp': value.UnrelatedOrgTxblPartnershipGrp === undefined ? undefined : ((value.UnrelatedOrgTxblPartnershipGrp as Array<any>).map(ExecRiskUnrelatedOrgTxblPartnershipToJSON)),
        'SupplementalInformationDetail': value.SupplementalInformationDetail === undefined ? undefined : ((value.SupplementalInformationDetail as Array<any>).map(ExecRiskSupplementalInformationDetailToJSON)),
    };
}

